import { useLocation } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import { useSeoSettings } from "@/hooks/useSeoSettings";

/**
 * Automatically applies SEO meta tags from seo_settings table
 * for the current route. Drop into any page or the global layout.
 */
const AutoSeoHead = () => {
  const { pathname } = useLocation();
  const seo = useSeoSettings(pathname);

  if (!seo) return null;

  return (
    <SeoHead
      title={seo.title || undefined}
      description={seo.description || undefined}
      ogTitle={seo.og_title || undefined}
      ogDescription={seo.og_description || undefined}
      ogImage={seo.og_image || undefined}
      canonicalUrl={seo.canonical_url || undefined}
      keywords={seo.keywords || undefined}
    />
  );
};

export default AutoSeoHead;
